import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

export default function AcessoNegado() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "50vh",
        px: 2,
      }}
    >
      <Card sx={{ maxWidth: 480, width: "100%" }}>
        <CardContent sx={{ textAlign: "center", py: 4 }}>
          <LockOutlinedIcon sx={{ fontSize: 56, color: "text.secondary", mb: 2 }} />
          <Typography variant="h5" component="h1" gutterBottom>
            Acesso negado
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Você não tem permissão para acessar esta área. Se precisar de acesso,
            solicite ao administrador do sistema.
          </Typography>
          <Button variant="contained" onClick={() => navigate("/dashboard")}>
            Ir para o painel
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
}
